import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { ElementName } from '../../../../../constants';
import { useFlexibleUiContext } from '../../../../../state/flexible-ui-context';
import { BaseDateTimeElement, toDateTimeProps } from '../common';
var SentOnElement = function SentOnElement(props) {
  var context = useFlexibleUiContext();
  var data = context ? toDateTimeProps('sent', context.sentOn) : null;
  return data ? /*#__PURE__*/React.createElement(BaseDateTimeElement, _extends({}, data, props, {
    name: ElementName.SentOn
  })) : null;
};
export default SentOnElement;